import React from 'react';
import Colors from '@data/enums/Color.enum';

export function milk({ fill = Colors.TEXT_DEFAULT }) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.57143 4.7619C7.57143 4.34112 7.91255 4 8.33333 4H11.381C11.8017 4 12.1429 4.34112 12.1429 4.7619C12.1429 5.18269 11.8017 5.52381 11.381 5.52381H8.33333C7.91255 5.52381 7.57143 5.18269 7.57143 4.7619Z'
        fill={fill} />
      <path d='M7.68033 6.37351C7.97253 5.41603 8.85607 4.7619 9.85714 4.7619C10.8582 4.7619 11.7418 5.41603 12.034 6.37351L12.3216 7.31602C12.5819 8.16913 12.7143 9.05616 12.7143 9.94811V13.1429C12.7143 14.7208 11.4351 16 9.85714 16C8.27919 16 7 14.7208 7 13.1429V9.94811C7 9.05615 7.13234 8.16913 7.39269 7.31602L7.68033 6.37351Z'
        fill={fill} />
      <path d='M11.3418 10.1353C11.7908 10.091 12.2416 10.1027 12.5146 10.1206V14.8452C12.5146 15.3698 12.0817 15.8003 11.542 15.8003H8.17188C7.63233 15.8001 7.20026 15.3697 7.2002 14.8452V10.9692C7.52562 11.1624 8.00556 11.3637 8.53809 11.3638C8.7987 11.3638 9.06757 11.2787 9.32324 11.1646C9.58031 11.0497 9.84159 10.8974 10.0889 10.7485C10.3402 10.5972 10.5754 10.4511 10.7949 10.3364C11.017 10.2204 11.1988 10.1494 11.3418 10.1353Z'
        fill='white' stroke={fill} strokeWidth='0.4' />
    </svg>
  );
}
